import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { BaseDAO } from './baseDAO';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VesselImage } from 'anchor-shared/lib/model/entity/vesselImage';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class VesselImageDAO extends BaseDAO<VesselImage> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.VESSEL_IMAGE);
  }

  public createAssociationFor(
    vesselId: number,
    resource: Partial<VesselImage>,
  ): Observable<VesselImage> {
    const url: string = this.apiHelper.getServiceName() + this.getResource();
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<VesselImage>(
      url,
      method,
      null,
      resource,
      headers,
    );
  }

  /**
   * returns all cropped images for the vessel
   * @param vesselId
   */
  public getCroppedByVesselId(vesselId: number): Observable<VesselImage[]> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/vessel/cropped/' +
      vesselId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {};
    return this.apiHelper.apiCall<VesselImage[]>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  public getAllByVesselId(vesselId: number): Observable<VesselImage[]> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/vessel/' +
      vesselId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {};
    return this.apiHelper.apiCall<VesselImage[]>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  public updateFromPartial(
    photoId: number,
    partialImage: Partial<VesselImage>,
  ) {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/' + photoId;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<VesselImage>(
      url,
      method,
      null,
      partialImage,
      headers,
    );
  }
}
